import { PrimaryButton } from "../Buttons/PrimaryButton";
import { SecondaryButton } from "../Buttons/SecondaryButton";
import { DialogFrame } from "../Dialogs/dialog-base";
import { CustomInput } from "../Input/CustomInput";

interface EmailDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: () => void;
}

export default function EmailDialog({
  open,
  setOpen,
  email,
  onEmailChange,
  onSubmit,
}: EmailDialogProps) {
  // Very rough email regex, not intended as a security feature.
  // It is only slightly better than string.contains(@) but also avoids missing tld.
  const emailIsValid = () => /.+@.+\..+/.test(email);

  const submit = () => {
    if (!emailIsValid()) return;
    onSubmit();
    setOpen(false);
  };

  return (
    <DialogFrame
      dialogOption={{
        closeDialog: () => setOpen(false),
        openDialog: () => setOpen(true),
        isOpen: open,
      }}
    >
      <h3 className="text-left text-base font-bold pb-2">Send preview</h3>
      <p>Type the Email you wish to send the preview to.</p>
      <CustomInput
        className="my-4"
        type="text"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
      />
      <div className="flex flex-row gap-3 justify-between">
        <SecondaryButton onClick={() => setOpen(false)}>Cancel</SecondaryButton>
        <PrimaryButton disabled={!emailIsValid()} onClick={submit}>
          Send email
        </PrimaryButton>
      </div>
    </DialogFrame>
  );
}
